import { Cart } from '@medusajs/medusa'
import { ValidateDiscountCodeDto, RemoveDiscountCodeDto } from '../dtos/discount.dto'
import { DiscountRepository } from '../repositories/discount'
import {
    ValidateDiscountCodeSchema,
    RemoveDiscountCodeSchema,
} from '../schemas/discount.schema'

type InjectedDependencies = {
    discountRepository: DiscountRepository
}

export class DiscountService {
    private readonly _discountRepository: DiscountRepository

    constructor({ discountRepository }: InjectedDependencies) {
        this._discountRepository = discountRepository
    }

    async validateAndApply(dto: ValidateDiscountCodeDto) {
        const validated = await ValidateDiscountCodeSchema.safeParseAsync(dto)
        if (!validated.success) {
            throw new Error('Code promo ou panier invalide.')
        }
        return await this._discountRepository.validateAndApply(validated.data)
    }

    async remove(dto: RemoveDiscountCodeDto): Promise<Cart> {
        const validated = await RemoveDiscountCodeSchema.safeParseAsync(dto)
        if (!validated.success) {
            throw new Error('Données invalides pour la suppression du code promo.')
        }
        return await this._discountRepository.remove(validated.data)
    }
}
